import React from 'react';
import Error from 'yoda-core-components/lib/assets/svg/errorFill.svg';

export const messageTypes = {
    error: 'error',
};

export const messageTypeIconMapping = {
    error: <Error />,
};

export const messageText = {
    error: {
        title: 'Coupon not applied',
        subTitle: "Oops. We couldn't process this request. Please try again.",
    },
    errorText: {
        title: 'Oh no! The code you selected has already expired. Please apply an eligible coupon.',
    },
};

export const Config = {
    COUPON_POPUP_MESSAGES_ID: 'COUPON_POPUP_MESSAGES_ID',
};

export const COUPON_EXPIRED_ID = 'SRV_COUPON_EXPIRED_ERR';
